<template>
  <div class="concordance-row">
    <b-row
      :title="this.$t('concordance.document_info')"
      class="justify-content-md-center"
      @click="getTaskId(data.id)"
    >
      <b-col cols="5" class="concordance-right">{{ getTitle }}</b-col>
      <b-col cols="5" class="concordance-center">{{ getPeriod }}</b-col>
      <b-col cols="2" class="concordance-left">{{ getFullDate }}</b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import VueAxios from "vue-axios";
import FadeTransition from "@/components/FadeTransition.vue";

export default {
  name: "DocListRow",
  props: ["data", "documentRequest"],
  data() {
    return {
      task: {
        id: null,
        status: "",
        result: "",
        finished: false,
      },
      documents: [],
    };
  },
  components: { axios, VueAxios, FadeTransition },
  methods: {
    getTaskId: async function (documentId) {
      try {
        let task = {
          corpus: "chronopress",
          task_type: "document",
          metadata_filter: [],
          query_parameters: [
            {
              name: "document_id",
              value: documentId.toString(),
            },
          ],
          response_parameters: [],
        };
        let response = await axios.post(
          process.env.ROOT_API + "startTask",
          task,
          {
            headers: {
              "Content-Type": "application/json",
            },
            crossDomain: true,
            timeout: 5000,
          }
        );
        this.task.id = response.data.id;
        this.checkStatus(this.task.id, 100);
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    checkStatus: async function (taskId, timer) {
      try {
        let response = await axios.get(
          process.env.ROOT_API + "getStatus/" + taskId,
          { timeout: 1000 }
        );
        this.task.status = response.data.status;
        if (this.task.status === "DONE") {
          this.getResult(taskId);
        } else if (this.task.status === "QUEUE") {
          timer += 100;
          setTimeout(() => {
            this.checkStatus(taskId);
          }, timer);
        } else if (this.task.status === "ERROR") {
          console.log(response);
        }
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    getResult: async function (taskId) {
      try {
        let response = await axios.get(
          process.env.ROOT_API + "getResult/" + taskId,
          { timeout: 5000 }
        );
        this.documentRequest(response);
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
  },
  computed: {
    getTitle: function () {
      let result = "no-data";
      this.data.metadata.properties.forEach((meta) => {
        if (meta.name === "journal_title") {
          result = meta.value;
        }
      });
      return result;
    },
    getPeriod: function () {
      let result = "no-data";
      this.data.metadata.properties.forEach((meta) => {
        if (meta.name === "period") {
          result = meta.value;
        }
      });
      return result;
    },
    getFullDate: function () {
      let d, y, m;
      this.data.metadata.properties.forEach((meta) => {
        if (meta.name === "publication_year") {
          y = meta.value;
        }
        if (meta.name === "publication_day") {
          d = meta.value;
        }
        if (meta.name === "publication_month") {
          m = meta.value;
        }
      });
      return d.padStart(2, "0") + "-" + m.padStart(2, "0") + "-" + y;
    },
  },
};
</script>

<style scoped>
.concordance-row {
  border-bottom: 3px solid var(--dark_silver);
}
.concordance-row:hover {
  cursor: pointer;
  background-color: var(--white_grey);
  border-bottom: 3px solid var(--grey_dark1);
  box-shadow: 0 -3px 0 0px var(--grey_dark1);
}
.concordance-right {
  width: 50%;
  padding: 10px;
  color: var(--grey_black);
}
.concordance-center {
  margin: auto;
  color: var(--grey_dark1);
}
.concordance-left {
  width: 50%;
  padding: 10px;
  color: var(--grey_black);
}
</style>



// WEBPACK FOOTER //
// src/components/DocListRow.vue